import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const AWSMarketplaceModal = ({ open, onClose, marketplaceDetails }) => {
  if (!marketplaceDetails) return null; // Return null if there's no data to show

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>AWS Marketplace Details</DialogTitle>
      <DialogContent>
        <div>
          <strong>Offer ID:</strong> {marketplaceDetails.offerId || 'N/A'}
        </div>
        <div>
          <strong>Agreement ID:</strong> {marketplaceDetails.agreementId || 'N/A'}
        </div>
        {/* Add more fields from marketplaceDetails if needed */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AWSMarketplaceModal;
